<script setup>
import { inject } from 'vue';

defineProps({
    value: {
        required: true,
        type: String,
    },
    submittingValue: {
        required: false,
        type: String,
    },
    as: {
        required: false,
        default: 'app-button',
    },
    disableOnClean: {
        required: false,
        default: true,
    },
});

const form = inject('form');
</script>

<template>
    <component :is="as" :loading="form.submitting" :disabled="form.disabled || (disableOnClean && form.isClean)">
        {{ form.submitting && submittingValue ? submittingValue : value }}
    </component>
</template>
